import CapitalConstruction from "./CapitalConstruction"

export default CapitalConstruction
